<template>
  <div v-if="order" class="overlay" v-htmlclass='{"overlay-open": value}' @click="onClickOutside">
    <div class="overlay__window">
      <div v-show="!showPrepare && !showReady"  class="overlay__content">
        <button type="button" class="overlay__close-btn" @click.prevent="onCloseButton"></button>
        <h2>Order Nr. <span v-html="order.number" /></h2>

        <h3 class="overlay__text">{{ order.order_label }}</h3>
        <div class="overlay__text overlay__text--small" v-if="order.pagernumber">Pager: {{ order.pagernumber }}</div>
        <div class="overlay__text overlay__text--small" v-if="order.trackernumber">Tracker: {{ order.trackernumber }}</div>

        <a href="" class="btn" @click.prevent="onChangeStateClick('new')">New Order</a>

        <a
          href=""
          class="btn btn--yellow"
          @click.prevent="onChangeStateClick('in_production')"
        >Preparation</a>

        <a
          v-if="hasFeature('FEATURE_PREPAREBOXES')"
          href=""
          class="btn btn--yellow"
          @click.prevent="onPrepareBoxClick"
        >Preparation Box</a>

        <a href="" class="btn btn--green" @click.prevent="onReadyClick()">Ready</a>
        <a
          href=""
          class="btn btn--blue"
          @click.prevent="onChangeStateClick('done')"
        >Order picked-up</a>
      </div>

      <div v-show="showPrepare"  class="overlay__content">
        <button type="button" class="overlay__close-btn" @click.prevent="onCloseButton"></button>

        <h2>Choose Box</h2>
        <h3 class="overlay__text">Preparation</h3>
        <div
          class="control__grid control__grid--pick-up"
          :class="[
            `control__grid--cols-${boxColumns}`
          ]"
        >
          <OrderBox v-for="item in currentPrepare" :order="item" :key="item.box" @click="onSelectBox(item, 'in_prep_')"></OrderBox>
        </div>

        <a href="" class="btn" @click.prevent="onPrepareCloseClick">Zurück</a>
      </div>

      <div v-show="showReady"  class="overlay__content">
        <button type="button" class="overlay__close-btn" @click.prevent="onCloseButton"></button>

        <h2>Choose Box</h2>
        <h3 class="overlay__text">Ready</h3>
        <div
          class="control__grid control__grid--pick-up"
          :class="[
            `control__grid--cols-${boxColumns}`
          ]"
        >
          <OrderBox v-for="item in currentPickups" :order="item" :key="item.box" @click="onSelectBox(item, 'in_box_')"></OrderBox>
        </div>

        <a href="" class="btn" @click.prevent="onReadyCloseClick">Zurück</a>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@num/config'
import OrderBox from './OrderBox'

export default {
  components: {
    OrderBox
  },
  props: {
    boxColumns: {
      default() {
        return 3;
      }
    },
    value: {
      required: true
    },
    order: {

    },
    currentPickups: {

    },
    currentPrepare: {

    }
  },
  data() {
    return {
      showPrepare: false,
      showReady: false,
      orderbox: Array.from(new Array(config.ORDERBOXES), (item, i) => ({ status: "empty", box: i + 1 }))
    }
  },
  methods: {
    onCloseButton() {
      this.onPrepareCloseClick();
      this.onReadyCloseClick();
      // this.$emit("close");
      this.$emit("input", false);
    },
    onChangeStateClick(status) {
      this.showReady = false
      console.debug("OverlayOrderUpdate: %s change to '%s'", this.order.id, status)
      this.$emit("changestate", status);
    },
    onPrepareBoxClick() {
      this.showPrepare = true
    },
    onPrepareCloseClick() {
      this.showPrepare = false
    },
    onReadyClick() {
      this.showReady = true
    },
    onReadyCloseClick() {
      this.showReady = false
    },
    onClickOutside(e) {
      if (e.currentTarget === e.target) {
        this.onCloseButton();
      }
    },
    onSelectBox(box, toBoxState) {
      if (box.status == "empty") {
        let status = toBoxState + box.box
        console.debug("OverlayOrderUpdate: %s change to '%s'", this.order.id, status)
        this.showReady = false
        this.showPrepare = false
        this.$emit("changestate", status);
      }
    }
  }
};
</script>

<style>
</style>
